import React, { Component } from "react";
import hoistNonReactStatic from "hoist-non-react-statics";
import withDesignConsumer from "./withDesignConsumer";

let withDesign;

if (process.env.DESIGNER === "yes") {
  withDesign = (WrappedComponent, Designer) => {
    const WithDesign = withDesignConsumer(
      class WithDesign extends Component {
        componentDidMount = () => {
          if (Designer) {
            const {
              children,
              designers,
              registerDesigner,
              ...rest
            } = this.props;

            [
              this.getDesignProps,
              this.setDesignProps,
              this.unregister
            ] = this.props.registerDesigner(Designer, rest);
          }
        };

        componentWillUnmount = () => {
          this.unregister && this.unregister();
          delete this.getDesignProps;
          delete this.setDesignProps;
          delete this.register;
        };

        render() {
          const { children, designers, registerDesigner, ...rest } = this.props;
          const designProps = this.getDesignProps ? this.getDesignProps() : {};

          return (
            <WrappedComponent
              {...rest}
              {...designProps}
              getDesignProps={this.getDesignProps}
              setDesignProps={this.setDesignProps}
            >
              {children}
            </WrappedComponent>
          );
        }
      }
    );

    WithDesign.displayName = `withDesign(${WrappedComponent.displayName ||
      WrappedComponent.name})`;
    WithDesign.WrappedComponent = WrappedComponent;

    return hoistNonReactStatic(WithDesign, WrappedComponent);
  };
} else {
  withDesign = WrappedComponent => WrappedComponent;
}

export default withDesign;
